import { type SupportedChain } from '@pkg/types';

import config from '@app/config';

const { nftOpenseaLink, tokenContractAddress } = config;

interface NftDetailsUrlType {
    contractAddress: string;
    tokenId: string;
    chain?: SupportedChain;
    goBackEnabled?: boolean;
}

export function getCollectionEthUrl(slug = '', chain) {
    return slug.length ? `/collection/${chain}/${slug}` : undefined;
}

export function getNftDetailsUrl({ contractAddress, tokenId, chain, goBackEnabled = false }: NftDetailsUrlType) {
    let suffix = '';
    const search: Record<string, string> = {};

    if (goBackEnabled) {
        search['goBack'] = '1';
    }

    if (Object.keys(search).length) {
        suffix = `?${new URLSearchParams(search).toString()}`;
    }

    return `/collectible/${chain}/${contractAddress}/${tokenId}${suffix}`;
}

export function getYatDetailsUrl(tokenId?: string | number | null) {
    return tokenId === null ? `/collection/ethereum/yat` : `/collectible/ethereum/${tokenContractAddress}/${tokenId}`;
}

export function getOpenSeaMintedYatUrl(tokenId?: string | number | null) {
    const safeToken = tokenId ? `${tokenId}` : '';
    const chain = process.env.NODE_ENV === 'development' ? 'sepolia' : 'ethereum';

    return safeToken
        ? `${nftOpenseaLink}/${chain}/${tokenContractAddress}/${safeToken}`
        : 'https://opensea.io/collection/yat';
}

export function getAppUrl(path = '') {
    const publicUrl = config.publicUrl;
    const linkPrefix = `${window.location.protocol}//`;
    const baseUrl = `${linkPrefix}${publicUrl}`;

    return path.substring(0, 1) !== '/' ? `${baseUrl}/${path}` : `${baseUrl}${path}`;
}
